// @flow
import React from 'react';
import PropTypes from 'prop-types';
import {makeStyles} from '@material-ui/core/styles';
import {Grid, Typography} from '@material-ui/core';
import Skeleton from '@material-ui/lab/Skeleton';

import withoutReferreds from '../../../../assets/img/withoutReferreds.png';
import AccordionReferrer from './AccordionReferral';
import type {Referred, Pagination} from '../../../../entities';
import CustomButton from '../../../../elements/CustomButton/CustomButton';
import {SIZE} from '../../duck';

type Props = {
  referreds?: Referred[],
  isFetchingReferreds?: boolean,
  handleAddPage: () => void,
  pagination?: Pagination,
};

const useStyles = makeStyles(theme => ({
  wrapperTitle: {
    position: 'relative',
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
  },
  subTitleRight: {
    position: ' absolute',
    right: 0,
    color: '#3A3A49',
    fontWeight: 600,
    fontSize: '18px',
  },
  subTitleLeft: {
    position: ' absolute',
    left: 0,
    color: '#3A3A49',
    fontWeight: 600,
    fontSize: '18px',
  },
  infoReferres: {
    textAlign: 'center',
    color: '#3A3A49',
    fontWeight: 600,
    fontSize: '18px',
  },
  obtainText: {
    marginTop: theme.spacing(1),
    textAlign: 'center',
    fontSize: '14px',
    color: '#55556D',
    '& span': {
      fontWeight: 600,
    },
  },
  containerText: {
    margin: theme.spacing(4, 0),
  },
  containeReferreds: {
    width: '100%',
    margin: theme.spacing(4, 0),
    display: 'flex',
    justifyContent: 'flex-start',
  },
  containerWithoutReferreds: {
    margin: theme.spacing(8, 0, 4, 0),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
}));

export default function TopReferrals(props: Props) {
  const {referreds, pagination, isFetchingReferreds, handleAddPage} = props;
  const classes = useStyles();

  const accordionReferrer = (
    <Grid container>
      {referreds &&
        referreds.map((ref: Referred, i) => (
          <AccordionReferrer key={`referer-${i + 1}`} referred={ref} />
        ))}
    </Grid>
  );

  return (
    <>
      <div className={classes.wrapperTitle}>
        <Typography className={classes.subTitleLeft}>Referidos Top</Typography>
        {referreds && referreds.length > 0 && (
          <Typography className={classes.subTitleRight}>Puntos</Typography>
        )}
      </div>
      {referreds && referreds.length > 0 ? (
        <div className={classes.containeReferreds}>{accordionReferrer}</div>
      ) : (
        referreds &&
        referreds.length === 0 && (
          <div className={classes.containerWithoutReferreds}>
            <img src={withoutReferreds} alt="without referreds" />
            <div className={classes.containerText}>
              <Typography className={classes.infoReferres}>
                Ayuda a tus amigos a conocer TiendaDa e impulsar sus
                emprendimientos.
              </Typography>
              <Typography className={classes.obtainText}>
                Y tú, <span>GANA puntos</span> para obtener funcionalidades PRO
                y aumentar tus ventas.
              </Typography>
            </div>
          </div>
        )
      )}
      {isFetchingReferreds && (
        <Skeleton
          variant="rect"
          height={'50px'}
          width="100%"
          style={{
            margin: referreds && referreds.length ? '-16px 0 16px 0' : '32px 0',
          }}
        />
      )}
      {referreds &&
      pagination &&
      pagination.total > SIZE &&
      referreds.length < pagination.total ? (
        <CustomButton onClick={handleAddPage} disabled={isFetchingReferreds}>
          Ver más
        </CustomButton>
      ) : null}
    </>
  );
}

TopReferrals.propTypes = {
  referreds: PropTypes.array,
  isFetchingReferreds: PropTypes.bool,
  handleAddPage: PropTypes.func.isRequired,
  pagination: PropTypes.object,
};
